import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ADIProductAvailability from "@NA/Components/RecentlyPurchasedProduct/ADIProductAvailability";
import ADIProductDeliveryInfo from "@NA/Components/RecentlyPurchasedProduct/ADIProductDeliveryInfo";
import ADIProductDescription from "@NA/Components/RecentlyPurchasedProduct/ADIProductDescription";
import ADIProductImage from "@NA/Components/RecentlyPurchasedProduct/ADIProductImage";
import ProductPrice, { ProductPriceStyles } from "@NA/Overrides/Components/ProductPrice";
import ADIColors from "@NA/Utils/ADIColors";
import ProductComapreCheckbox, {
    ProductComapreCheckboxStyles,
} from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import ADIProductAddToCartButton from "@NA/Components/ProductDetail/ADIProductAddToCartButton";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { isPriceAvailable } from "@NA/Utils/Utility";
import { AdiProductAddToCartButtonStyles } from "@NA/Components/RecentlyPurchasedProduct/ADIProductAddToCartButton";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import CrossIcon from "@NA/Icons/CrossIcon";
import siteMessage from "@insite/client-framework/SiteMessage";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import ADIProductSaleInfo from "../ProductList/ADIProductSaleInfo";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
        productSettings: getSettingsCollection(state).productSettings,
        session,
        state,
        settingsCollection: getSettingsCollection(state),
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        customerNumber,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

const mapDispatchToProps = {
    updateProductInfo,
    toggleLoginDrawer,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    showImage: boolean;
    showBrand: boolean | undefined;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: ProductCarouselProductStyles;
    view: string;
    showAvailability: boolean;
    isAdiChoice?: boolean;
    sourceName: string;
    showItemCompare?: boolean;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productDescriptionContainer?: InjectableCss;
    productPartNumbersContainer?: InjectableCss;
    imageWrapper?: InjectableCss;
    mobLeftSideContainer?: InjectableCss;
    showAuthContainer?: InjectableCss;
    showDesktopAuthContainer?: InjectableCss;
    mobProdPartNumbers?: InjectableCss;
    mainContainer?: InjectableCss;
    mobRightSideContainer?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPartsDetailsGrid?: InjectableCss;
    productPartsDetailsList?: InjectableCss;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: InjectableCss;
    addToCartContainerWithoutSignIn?: InjectableCss;
    isPendingVerificationSignIn?: InjectableCss;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: InjectableCss;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    availabilityGridItem?: InjectableCss;
    addToCartStyles?: AdiProductAddToCartButtonStyles;
    availabilityStyles?: ProductAvailabilityStyles;
    productComapreCheckboxStyles?: ProductComapreCheckboxStyles;
    productPriceStyles?: ProductPriceStyles;
    signInDealerPrice?: InjectableCss;
    dealerPriceText?: TypographyProps;
    dealerCertificationModal?: ModalPresentationProps;
    dealerMsg?: InjectableCss;
    continue?: InjectableCss;
    vendorLink?: InjectableCss;
    stylesdealerTitle?: InjectableCss;
    showAuthInnerContainer?: InjectableCss;
    getCertifiedText?: InjectableCss;
    productCategory?: InjectableCss;
    tags?: InjectableCss;
    saletagparent?: InjectableCss;
    VerificationText?: TypographyPresentationProps;
    dealerCertificationWrapper?:InjectableCss
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    productBrandWrapper: {
        css: css`
            margin: 0px 0;
            line-height: 1;
            display: inline-flex;
            width: 100%;
            padding: 0px 20px;
            display: block;
            a:hover {
                text-decoration: underline;
            }
            @media screen and (max-width: 767px) {
                > a {
                    span {
                        font-size: 10px;
                    }
                }
            }
        `,
    },
    isPendingVerificationSignIn: {
        css: css`
            flex-grow: 0;
            padding-top: 35px;
            margin: 20px;
            cursor: auto;
            > div:hover {
                background-color: transparent;
                span {
                    color: ${ADIColors.darkBlue1};
                }
            }
            span {
                color: ${ADIColors.darkBlue1};
            }
        `,
    },

    tags: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 4px 15px !important;
            background-color: #2380a3;
            flex-grow: 0;
            font-size: 12px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff;
            border-radius: 0;
            border-top-left-radius: 5px;
            border-bottom-right-radius: 5px;
            min-height: 24px;
            width: auto;
            line-height: 1;
            white-space: normal;
            height: auto;
        `,
    },
    saletagparent: {
        css: css`
            position: absolute;
        `,
    },
    dealerCertificationModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
            css: css`
            button {
                font-size:16px;
                font-weight: 700;
                `,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 521px !important;
                border-radius: 4px;
                padding: 28px 28px 38px 28px !important;
                position: fixed;
                top: 100px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: auto;
                            `,
                            null,
                            null,
                            css`
                                max-height: fit-content;
                            `,
                            null,
                        ],
                        "min",
                    );
                }}
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 28px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: 1.07;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    margin-top: -45px;
                    margin-right: -20px;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    dealerMsg: {
        css: css`
            padding-bottom: 20px;
            font-size: 14px;
            line-height: 1.71;
            font-weight: normal;
        `,
    },
    continue: {
        css: css`
            min-height: 21px;
            padding: 10px 20px;
            line-height: 21px;
            border: 0px;
        `,
    },
    vendorLink: {
        css: css`
            margin-left: 2px;
        `,
    },
    showAuthInnerContainer: {
        css: css`
            width: 100%;
            text-align: center;
            border-top: solid 1px ${ADIColors.gray7};
            padding: 10px 10px !important;
            height: 64px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        `,
    },
    stylesdealerTitle: {
        css: css`
            line-height: 30px;
            color: ${ADIColors.darkBlue1};
            font-size: 17px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            text-align: center;
            display: block;
            line-height: 1;
            @media only screen and (min-width: 1080px) and (max-width: 1440px) {
                font-size: 12px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-word;
            }
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                font-size: 16px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-word;
            }
        `,
    },
    getCertifiedText: {
        css: css`
            > span {
                text-transform: none !important;
                font-size: 14px !important;
                font-weight: bold;
                &:hover {
                    text-decoration: underline !important;
                    color: #006ae3 !important;
                }
            }
        `,
    },
    addToCartStyles: {
        priceAvailibility: {
            css: css`
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                padding: 0 15px 15px;
                span {
                    font-weight: bold;
                    font-size: ${getProp("theme.typography.headerSecondary.size")};
                }
                @media screen and (max-width: 767px) {
                    padding: 0px 20px;
                }
            `,
        },
        addToCartButton: {
            css: css`
                width: 100%;
                text-align: center;
                padding: 20px 0;
                cursor: pointer;
                transition: 0.2s ease;
                margin-top: auto;
                border-radius: 0;
                background: ${ADIColors.white};
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                :disabled {
                    background: ${ADIColors.white} !important;
                    cursor: not-allowed;
                }
                span {
                    color: ${getColor("primary")};
                }
                :hover {
                    background-color: ${getColor("primary")};
                    span {
                        color: ${ADIColors.white};
                    }
                }

                img {
                    width: 40px;
                }
            `,
        },
    },
    productComapreCheckboxStyles: {
        wrapper: {
            css: css`
                div[class^="CheckboxStyle"] {
                    flex-direction: row-reverse;
                    margin: 4px 10px 0px 0px;
                }
            `,
        },
    },
    productDescriptionContainer: {
        css: css`
            padding: 0px 20px;
            line-height: normal;
            margin-top: 5px;
            @media screen and (max-width: 767px) {
                > a span {
                    font-size: 16px;
                    -webkit-line-clamp: 3 !important;
                }
            }
        `,
    },
    productPartNumbersContainer: {
        css: css`
            padding: 0px 20px;
            @media screen and (max-width: 767px) {
                span[data-test-selector="productNumber"],
                span[data-test-selector="manufacturerItem"] {
                    text-align: center;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    availabilityGridItem: {
        css: css`
            padding: 0 20px;
            margin-top: 10px;
            @media screen and (max-width: 767px) {
                margin-top: 0px;
                button {
                    span {
                        font-size: 14px;
                    }
                }
            }
        `,
    },
    imageWrapper: {
        css: css`
            margin: 0;
            padding: 20px;
            margin-top: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 30px;
                    `,
                    css`
                        margin-top: 30px;
                    `,
                    null,
                    null,
                    null,
                ])}
            img {
                max-height: 160px;
                max-width: 231px;
                height: 160px;
                width: auto;
                margin: 0 auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            height: auto;
                            width: 100%;
                        `,
                    css`
                            height: auto;
                            width: 100%;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            flex-flow: row;
            flex-wrap: wrap;

            @media screen and (max-width: 767px) {
                padding-bottom: 80px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobLeftSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    showAuthContainer: {
        css: css`
            display: flex;
            height: 100%;
            align-items: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    showDesktopAuthContainer: {
        css: css`
            display: flex;
            height: 100%;
            align-items: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                ])}
        `,
    },
    mobProdPartNumbers: {
        css: css`
            margin-top: 10px;
            div[class^="GridOffset"] {
                // flex-direction: column-reverse;
                // align-items: center;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                    `,
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    mobRightSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 60%;
                        display: inline-block;
                        //min-height: 310PX;
                        padding-top: 30px;
                    `,
                    css`
                        width: 60%;
                        display: inline-block;
                        //min-height: 310PX;
                        padding-top: 30px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            css: css`
                margin-bottom: 5px;
                span {
                    color: ${getColor("text.main")} !important;
                }
            `,
        },
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                flex-grow: 0;
                margin-bottom: 5px;
                span {
                    color: ${getColor("text.main")} !important;
                }
                div {
                    @media screen and (max-width: 767px) {
                        padding: 0px;
                    }

                    span[class^="TypographyStyle"] {
                        font-size: 10px;
                        font-weight: 600;
                        line-height: normal;
                        color: ${ADIColors.gray4};
                        @media screen and (max-width: 767px) {
                            text-align: center;
                        }
                    }
                    // span[data-test-selector="productNumber"] {
                    //     &::after {
                    //         content: "|";
                    //         font-size: 10px;
                    //         color: ${ADIColors.gray4};
                    //         font-weight: 600;
                    //         height: 14px;
                    //         margin: 0;
                    //         position: relative;
                    //         left: 0;
                    //         top: -0.5px;
                    //         padding-right: 3px;
                    //         padding-left: 5px;
                    //     }
                    // }
                }
                div[class^="GridItemStyle"] {
                    margin-right: 0 !important;
                    padding-top: 0px;
                    padding-bottom: 0px;
                }
            `,
        },

        // commented in CA spire ---P21 Chnages
        // erpNumberLabelText: { size: 13 },
        // erpNumberValueText: { size: 13 },
    },
    productPriceWrapper: {
        css: css`
            flex-grow: 1;
            margin-bottom: 6px;
            padding: 0px 20px;
            [data-test-selector="productPrice"] {
                align-items: center;
                display: flex;
            }
        `,
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 6px;
            `,
        },
    },
    productPriceStyles: {
        price: {
            priceText: {
                weight: "bold",
                css: css`
                    color: ${ADIColors.darkBlue4};
                    display: flex;
                    flex-wrap: wrap;
                    .symbolText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-right: 2px;
                        position: relative;
                        top: 0px;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                    font-size: 12px;
                                `,
                            css`
                                    font-size: 12px;
                                `,
                            null,
                            null,
                            null,
                        ])}
                    }
                    .priceText {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 1.1;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                    font-size: 20px;
                                `,
                            css`
                                    font-size: 20px;
                                `,
                            null,
                            null,
                            null,
                        ])}
                    }
                    .currencyText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 2px;
                        position: relative;
                        top: -2px;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                    font-size: 12px;
                                    top: -1px;
                                `,
                            css`
                                    font-size: 12px;
                                    top: -1px;
                                `,
                            null,
                            null,
                            null,
                        ])}
                    }
                    .unitofmeasureText {
                        font-size: 12px !important;
                        position: relative;
                        font-weight: 600;
                        color: #666;
                        display: block !important;
                    }
                `,
            },
        },
    },
    addToCartContainer: {
        css: css`
            flex-grow: 0;
            padding-top: 20px;
            @media screen and (max-width: 767px) {
                margin-left: -66%;
                padding-top: 10px;
                > div {
                    button {
                        height: 64px;
                    }
                }
            }
        `,
    },
    addToCartContainerWithoutSignIn: {
        css: css`
            flex-grow: 0;
            padding-top: 35px;
            margin: 20px;
        `,
    },
    qtyGridItem: { width: 3 },
    productQuantityOrderedStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 0;
            `,
        },
    },
    productBrandStyles: {
        nameLink: {
            css: css`
                span {
                    color: ${getColor("text.main")} !important;
                    font-weight: 600 !important;
                }
            `,
        },
    },
    addToCartButtonGridItem: {
        css: css`
            button {
                height: 64px;
                border: 0px !important;
                border-top: 1px solid ${ADIColors.gray7} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            padding: 0;
                            height: 40px;
                            border-top: 0px;
                        `,
                    css`
                            padding: 0;
                            height: 40px;
                            border-top: 0px;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
        `,
    },
    productAddToCartButtonStyles: {
        css: css`
            width: 100%;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            typographyProps: { size: 13 },
            css: css`
                margin-bottom: 12px;
            `,
        },
    },
    signInDealerPrice: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            position: absolute;
            bottom: 0;
            width: 100%;
            left: 0;
            right: 0;
            margin-top: 30px;
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    dealerPriceText: {
        css: css`
            color: ${getColor("primary")};
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
        `,
    },
    productPartsDetailsGrid: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            line-height: 1;
            margin-bottom: 5px;
            > ${TypographyStyle} {
                margin-right: 5px;
                font-size: 10px;
                color: ${ADIColors.darkBlack3};
                font-weight: 600;
                &:last-child {
                    margin-right: 0px;
                }
            }
        `,
    },
    productPartsDetailsList: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            line-height: 1;
            margin-bottom: 5px;
            > ${TypographyStyle} {
                margin-right: 5px;
                font-size: 10px;
                color: ${ADIColors.darkBlack3};
                font-weight: 600;
                &:last-child {
                    margin-right: 0px;
                }
            }
        `,
    },
    productCategory: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            margin: 4px 0 4px 10px;
            display: inline-block;
            max-width: 100%;
            flex-basis: 100%;
            position: absolute;

            ${TypographyStyle} {
                color: ${ADIColors.darkBlack3};
                &:hover {
                    text-decoration: underline;
                    color: ${ADIColors.darkBlack3};
                }
            }
        `,
    },
    VerificationText: {
        css: css`
                           
                                text-transform: none !important;
                                font-size: 14px !important;
                                font-weight: bold;
                                color: ${ADIColors.blue5} !important;                              
                            }
                        `,
    },
    dealerCertificationWrapper: {
        css: css`
            border-top: solid 1px ${ADIColors.gray7};
            text-align: center;
            padding: 6.5px 4px !important;
            height: 55px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.productListView {
                border-top: none;
                justify-content: flex-start;
                align-items: flex-start;
                > div:first-child {
                    font-weight: 600;
                }
                > button > span {
                    padding-top: 10px;
                }
            }
        `,
    },
};

const ADIProductCarouselProduct: React.FC<Props> = React.memo(({
    carouselId,
    product,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    updateProductInfo,
    isAdiChoice,
    extendedStyles,
    view,
    session,
    toggleLoginDrawer,
    showADIAddToCart,
    state,
    sourceName,
    customerNumber,
    isAuthenticated,
    showItemCompare,
}) => {
    const styles = mergeToNew(productCarouselProductStyles, extendedStyles);
    const pricingStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.pricingStatus,
    );
    const isItemCompare = showItemCompare !== undefined ? showItemCompare : true;

    const productInfo: ProductInfo = isAdiChoice
        ? state.ADIGlobalData.ADIChoiceGlobalProductsStore.globalProductInfosByLineId![product.id]!
        : getProductInfoFromList(state, carouselId, product.id)!;
    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    let adiChoiceProductInfo;
    let adiChoiceProductInfoID;

    if (productInfo! && (productInfo as ProductInfo)) {
        adiChoiceProductInfoID = productInfo.productId;
        adiChoiceProductInfo = productInfo;
    }

    const openSignIn = () => {
        toggleLoginDrawer({
            loginDrawer: true,
        });
    };

    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const pricing = productInfo?.pricing || product.pricing;
    const pricingIsAvailable = isPriceAvailable(pricing, product.qtyOrdered);
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);
    const [isAccessories, setIsAccessories] = React.useState(false);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
        const getCustomerCreditStatus = useSelector(  
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );
    const hasPriceLoaded = useMemo(() => {
        if (productInfo && productInfo.hasOwnProperty("pricing")) {
            return true;
        }

        if (product && product.hasOwnProperty("pricing")) {
            return true;
        }

        return false;
    }, [productInfo, product]);

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };
    //  const isSale =  product.properties["classificatioN_CODE"] !== "X" && product.properties.onsalenow == "1";
    const isSale =
        product.properties["saletype"] != "ED" &&
        product.properties["saletype"] != "CD" &&
        product.properties["saletype"] != "DD" &&
        product.properties["saletype"] != "WS" &&
        product.properties["saletype"] != "OO" &&
        product.properties["saletype"] != "SD" &&
        product.properties["saletype"] != "LT" &&
        product.properties["saletype"] != "FS" &&
        product.properties["saletype"] != "BF" &&
        product.properties["saletype"] != "EV" &&
        product.properties["saletype"] != "SM" &&
        product.properties["saletype"] != "AC" &&
        product.properties["classificatioN_CODE"] != "X" &&
        product.properties["onsalenow"] == "1";

    const showAuthorizationRequired =
        pricing &&
            pricing.additionalResults &&
            pricing.additionalResults.isVisible &&
            pricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();
    const brandName = product.brand?.name ?? "";
    const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;

    const modelNumber =
        product && product.modelNumber ? product.modelNumber : product.manufacturerItem ? product.manufacturerItem : "";

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(brandName, vendorAuthRequiredLink, customerNumber, sourceName, session);
    };

    const [minDescHeight, setMinDescHeight] = useState(15);
    const [minPartHeight, setMinPartHeight] = useState(10);
    const [minPriceHeight, setMinPriceHeight] = useState(40);
    const [minStockAvailHeight, setStockAvailHeight] = useState(10);
    const [minContainerHeight, setContainerHeight] = useState(10);
    const carouselRef = useRef<HTMLDivElement>(null);
    const [accountPendingVerificatioPDP, setaccountPendingVerificatioPDP] = useState<string | null>(getCustomerCreditStatus?.getcustomerStatus?.creditStatus)
    useEffect(() => {
        setaccountPendingVerificatioPDP(getCustomerCreditStatus?.getcustomerStatus.creditStatus)
    }, [accountPendingVerificatioPDP,getCustomerCreditStatus?.getcustomerStatus.creditStatus]);

    useEffect(() => {
        if (carouselRef && carouselRef.current && carouselRef.current.parentElement) {
            const carouselRefId = carouselRef!.current!.parentElement!.parentElement!.parentElement!.id;
            const maxDescHeight = getMaxProductHeight(
                `#${carouselRefId} [data-test-selector="productDescriptionCarousel"]`,
            );
            const maxPartHeight = getMaxProductHeight(`#${carouselRefId} [data-test-selector="plpPartNumber"]`);
            const maxPriceHeight = getMaxProductHeight(`#${carouselRefId} [data-test-selector="productPrice"]`);
            const maxStockAvailHeight = getMaxProductHeight(
                `#${carouselRefId} [data-test-selector="productStockAvailHeightCarousel"]`,
            );

            setMinDescHeight(maxDescHeight);
            setMinPartHeight(maxPartHeight);
            setMinPriceHeight(maxPriceHeight);
            setStockAvailHeight(maxStockAvailHeight);          
            if (carouselRefId === "Accessory") {
                setIsAccessories(true);
            }

            const itemProductHeight = document.querySelectorAll(`#${carouselRefId} [data-test-selector="mobRightSideContainer"]`);
            
            if (window.innerWidth < 767) {
                let maxContainerHeight = 0;
                itemProductHeight.forEach(item => {
                    maxContainerHeight = Math.max(maxContainerHeight, item.clientHeight);
                });
                setContainerHeight(maxContainerHeight - 15);
            }
        }

    }, [productContext]);

    if (product || (productContext && productContext.productInfo && productContext.product)) {
        return (
            <>
                <ProductContext.Provider value={productContext} {...styles.mainContainer}>
                    {productContext?.product && productContext?.productInfo && (
                        <>
                            {!isAccessories && (
                                <>
                                    {isAuthenticated ? (
                                        <ADIProductSaleInfo
                                            product={product}
                                            isAuthenticated={true}
                                            pricing={pricing}
                                        />
                                    ) : (
                                        <>
                                            {/* <ADIProductSaleInfo product={product} isAuthenticated={false} pricing={pricing} /> */}
                                            {isSale ? (
                                                <StyledWrapper {...styles.saletagparent}>
                                                    <Typography className="saletag" {...styles.tags}>
                                                        {translate("Sale")}
                                                    </Typography>
                                                </StyledWrapper>
                                            ) : (
                                                <ADIProductSaleInfo
                                                    product={product}
                                                    isAuthenticated={false}
                                                    pricing={pricing}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            {isAccessories ? (
                                <Link {...styles.productCategory} href={product.properties["productcategoryurl"]}>
                                    {product.properties["productcategory"]}
                                </Link>
                            ) : null}

                            <StyledWrapper
                                {...styles.mobLeftSideContainer}
                                data-test-selector="mobLeftSideContainer"
                                ref={carouselRef}
                            >
                                {isItemCompare && isAuthenticated && !isAccessories && (
                                    <ProductComapreCheckbox extendedStyles={styles.productComapreCheckboxStyles} />
                                )}
                                <StyledWrapper {...styles.imageWrapper}>
                                    <ADIProductImage product={product} sourceName={sourceName} />
                                    <StyledWrapper {...styles.mobProdPartNumbers}>
                                        <ProductPartNumbers
                                            productNumber={product.erpNumber || product.productNumber}
                                            customerProductNumber={product.customerProductNumber}
                                            manufacturerItem={modelNumber}
                                            showCustomerName={false}
                                            showManufacturerItem={true}
                                            showLabel={false}
                                            extendedStyles={styles.productPartNumbersStyles}
                                        />
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>

                            <StyledWrapper {...styles.mobRightSideContainer} style={{ minHeight: minContainerHeight + "px" }}  data-test-selector="mobRightSideContainer">
                                {showBrand && product.brand && (
                                    <StyledWrapper {...styles.productBrandWrapper}>
                                        <ProductBrand
                                            brand={product.brand}
                                            extendedStyles={styles.productBrandStyles}
                                        />
                                    </StyledWrapper>
                                )}
                                {showTitle && (
                                    <StyledWrapper
                                        {...styles.productDescriptionContainer}
                                        data-test-selector="productDescriptionCarousel"
                                        style={{ minHeight: minDescHeight + "px" }}
                                    >
                                        <ADIProductDescription
                                            session={session}
                                            sourceName={sourceName}
                                            product={product}
                                            extendedStyles={styles.productDescriptionStyles}
                                        />
                                    </StyledWrapper>
                                )}
                                {showPartNumbers && (
                                    <StyledWrapper
                                        {...styles.productPartNumbersContainer}
                                        data-test-selector="plpPartNumber"
                                        style={{ minHeight: minPartHeight + "px" }}
                                    >
                                        <StyledWrapper
                                            {...(view === "Grid"
                                                ? styles.productPartsDetailsGrid
                                                : styles.productPartsDetailsList)}
                                        >
                                            <Typography as="span">{product.manufacturerItem}</Typography>
                                            <Typography as="span">|</Typography>
                                            <Typography as="span">{product.productNumber}</Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}
                                {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null
                                    ?
                                    <StyledWrapper
                                     {...styles.dealerCertificationWrapper}
                                      
                                    >

                                        <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography>


                                    </StyledWrapper> :
                                    (
                                    <>
                                        {session.isAuthenticated && showAuthorizationRequired !== "true" && (
                                            <>
                                                {showPrice && session.isAuthenticated && (
                                                    <StyledWrapper {...styles.productPriceWrapper}>
                                                        <VisuallyHidden
                                                            as="label"
                                                            htmlFor={`${carouselId}-uom`}
                                                            id={`${carouselId}-uom-label`}
                                                        >
                                                            {translate("U/M")}
                                                        </VisuallyHidden>

                                                        <StyledWrapper
                                                            style={{ minHeight: minPriceHeight + "px" }}
                                                            data-test-selector="productPrice"
                                                        >
                                                            {/* {productContext?.product?.unitOfMeasures && productContext?.productInfo?.unitOfMeasure && */}
                                                            <ProductPrice
                                                                showLabel={false}
                                                                product={productContext}
                                                                extendedStyles={styles.productPriceStyles}
                                                            />
                                                            {/* } */}
                                                        </StyledWrapper>
                                                        <ADIProductDeliveryInfo
                                                            product={product}
                                                            freeShippingAmount={freeShippingAmount}
                                                            showAuthorizationRequired={showAuthorizationRequired}
                                                        />
                                                        {/* {productContext?.productInfo?.pricing && */}
                                                        <ProductQuantityBreakPricing
                                                            extendedStyles={styles.productQuantityBreakPricingStyles}
                                                        />
                                                        {/* } */}
                                                    </StyledWrapper>
                                                )}
                                            </>
                                        )}
                                        {session.isAuthenticated && (
                                            <StyledWrapper
                                                {...styles.availabilityGridItem}
                                                data-test-selector="productStockAvailHeightCarousel"
                                                style={{ minHeight: minStockAvailHeight + "px" }}
                                            >
                                                <ADIProductAvailability
                                                    product={product}
                                                    view={view}
                                                    showAuthorizationRequired={showAuthorizationRequired}
                                                />
                                            </StyledWrapper>
                                        )}

                                        {session.isAuthenticated &&
                                            showAuthorizationRequired === "true" &&
                                            !isPendingVerification &&
                                            vendorAuthRequiredList === "false" ? (
                                            <StyledWrapper {...styles.showAuthContainer}>
                                                <StyledWrapper {...styles.showAuthInnerContainer}>
                                                    {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? <Typography {...styles.VerificationText} as="span">Account Pending Verification</Typography> :
                                                        <>
                                                            <StyledWrapper {...styles.stylesdealerTitle}>
                                                                Dealer Certification Required
                                                            </StyledWrapper>
                                                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                Get Certified
                                                            </Link>
                                                        </>}

                                                    <Modal
                                                        {...styles.dealerCertificationModal}
                                                        headline={translate("Dealer Certification Required")}
                                                        isOpen={dealerModalIsOpen}
                                                        handleClose={dealerModalCloseHandler}
                                                    >
                                                        <StyledWrapper {...styles.dealerMsg}>
                                                            {siteMessage("Dealer_Certification_Message")}
                                                        </StyledWrapper>
                                                        <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                            Continue Shopping
                                                        </Button>
                                                    </Modal>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ) : session.isAuthenticated &&
                                            showAuthorizationRequired === "true" &&
                                            !isPendingVerification &&
                                            vendorAuthRequiredList === "true" ? (
                                            <StyledWrapper {...styles.showAuthContainer}>
                                                <StyledWrapper {...styles.showAuthInnerContainer}>
                                                    {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? <Typography {...styles.VerificationText} as="span">Account Pending Verification</Typography> :
                                                        <>
                                                            <StyledWrapper {...styles.stylesdealerTitle}>
                                                                Dealer Certification Required
                                                            </StyledWrapper>
                                                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                                Get Certified
                                                            </Link>
                                                        </>
                                                    }

                                                    <Modal
                                                        {...styles.dealerCertificationModal}
                                                        headline={translate("Dealer Certification Required")}
                                                        isOpen={dealerModalIsOpen}
                                                        handleClose={dealerModalCloseHandler}
                                                    >
                                                        <StyledWrapper {...styles.dealerMsg}>
                                                            {siteMessage("Dealer_Vendor_Certification_Message")}
                                                            <Link
                                                                href={product.properties?.vendorAuthRequiredLink}
                                                                target="_blank"
                                                                onClick={clickHandler}
                                                                {...styles.vendorLink}
                                                            >
                                                                {" "}
                                                                {translate("vendor's form.")}
                                                            </Link>{" "}
                                                            {translate("For more information, call ")}
                                                            <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                                        </StyledWrapper>
                                                        <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                            Continue Shopping
                                                        </Button>
                                                    </Modal>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ) : (
                                            <>
                                                {isAdiChoice &&
                                                    !showPrice &&
                                                    !session.isAuthenticated &&
                                                    !isPendingVerification && (
                                                        <StyledWrapper {...styles.addToCartStyles?.priceAvailibility}>
                                                            <StyledWrapper>
                                                                {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? <Typography {...styles.VerificationText} as="span">
                                                                    {translate("Account Pending Verification")}
                                                                </Typography> : <Typography>{translate("Pricing Currently Not Available")}</Typography>}
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    )}
                                                {hasPriceLoaded &&
                                                    !isAdiChoice &&
                                                    showPrice &&
                                                    session.isAuthenticated &&
                                                    !pricingIsAvailable &&
                                                    !isPendingVerification && (
                                                        <StyledWrapper {...styles.addToCartStyles?.priceAvailibility}>
                                                            <StyledWrapper>

                                                                {localStorage.getItem("CreditStatus") !== "O" && localStorage.getItem("CreditStatus") !== "" && localStorage.getItem("CreditStatus") !== null ? <Typography {...styles.VerificationText} as="span">{translate("Account Pending Verification")}</Typography> : <Typography>{translate("Pricing Currently Not Available")}</Typography>}

                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    )}
                                                {showAddToCart && session.isAuthenticated && showADIAddToCart && (
                                                    <StyledWrapper {...styles.addToCartContainer}>
                                                        <StyledWrapper {...styles.addToCartButtonGridItem}>
                                                            {/* {productContext?.productInfo?.pricing && */}
                                                            <ADIProductAddToCartButton
                                                                sourceName={sourceName}
                                                                productLine={product}
                                                                buttonLabel="Add To Cart"
                                                            />
                                                            {/* } */}
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                )}
                                            </>
                                        )}
                                    </>
                                    )}
                            </StyledWrapper>
                            {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? "": <>
                            {session.isAuthenticated &&
                                !isPendingVerification &&
                                showAuthorizationRequired === "true" &&
                                vendorAuthRequiredList === "false" ? (
                                <StyledWrapper {...styles.showDesktopAuthContainer}>
                                    <StyledWrapper {...styles.showAuthInnerContainer}>

                                        {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? <Typography {...styles.VerificationText} as="span">Account Pending Verification</Typography> : 
                                        <StyledWrapper>
                                            <StyledWrapper {...styles.stylesdealerTitle}>
                                                Dealer Certification Required
                                            </StyledWrapper>
                                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                Get Certified
                                            </Link>
                                        </StyledWrapper>}

                                        <Modal
                                            {...styles.dealerCertificationModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            <StyledWrapper {...styles.dealerMsg}>
                                                {siteMessage("Dealer_Certification_Message")}
                                            </StyledWrapper>
                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                Continue Shopping
                                            </Button>
                                        </Modal>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : session.isAuthenticated &&
                                showAuthorizationRequired === "true" &&
                                !isPendingVerification &&
                                vendorAuthRequiredList === "true" ? (
                                <StyledWrapper {...styles.showDesktopAuthContainer}>
                                    <StyledWrapper {...styles.showAuthInnerContainer}>

                                        {accountPendingVerificatioPDP !== "O" && accountPendingVerificatioPDP !== "" && accountPendingVerificatioPDP !== null ? <Typography {...styles.VerificationText} as="span">Account Pending Verification</Typography> : <StyledWrapper>
                                            <StyledWrapper {...styles.stylesdealerTitle}>
                                                Dealer Certification Required
                                            </StyledWrapper>
                                            <Link {...styles.getCertifiedText} onClick={getCertified}>
                                                Get Certified
                                            </Link>
                                        </StyledWrapper>}

                                        <Modal
                                            {...styles.dealerCertificationModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            <StyledWrapper {...styles.dealerMsg}>
                                                {siteMessage("Dealer_Vendor_Certification_Message")}
                                                <Link
                                                    href={product.properties?.vendorAuthRequiredLink}
                                                    target="_blank"
                                                    onClick={clickHandler}
                                                    {...styles.vendorLink}
                                                >
                                                    {" "}
                                                    {translate("vendor's form.")}
                                                </Link>{" "}
                                                {translate("For more information, call ")}
                                                <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                            </StyledWrapper>
                                            <Button onClick={dealerModalCloseHandler} {...styles.continue}>
                                                Continue Shopping
                                            </Button>
                                        </Modal>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : null}
                            </>}
                        </>
                    )}
                </ProductContext.Provider>
                {!session.isAuthenticated && !isPendingVerification && (
                    <StyledWrapper {...styles.addToCartContainerWithoutSignIn} data-test-selector="signInDealer">
                        <StyledWrapper {...styles.signInDealerPrice} onClick={openSignIn}>
                            <Typography {...styles.dealerPriceText} as="span">
                                {translate("Sign In for Dealer Pricing")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {session.isAuthenticated && isPendingVerification && (
                    <StyledWrapper {...styles.isPendingVerificationSignIn} data-test-selector="signInDealer">
                        <StyledWrapper {...styles.signInDealerPrice} style={{ cursor: "auto" }}>
                            <Typography {...styles.dealerPriceText} as="span">
                                {translate("Account Pending Verification")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
            </>
        );
    } else {
        return null;
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ADIProductCarouselProduct);
